import { API } from 'api/config'
import { AxiosResponse } from 'axios'
import { Document, UploadDocumentCreedentialsResponse } from 'interfaces'
import { v4 as uuidv4 } from 'uuid'
import { getFormData } from '../myOrganizations'

export const uploadFile = async (
	slug: string,
	file: File
): Promise<Document | null> => {
	try {
		const { data }: AxiosResponse<UploadDocumentCreedentialsResponse> =
			await API().get(`/upload/documents?slug=${slug}`)
		const s3Url = data?.url
		if (!s3Url) throw new Error('Invalid credentials: missing S3 URL')
		const fileExtension = file.name.includes('.')
			? file.name.split('.').pop()
			: undefined
		if (!fileExtension) throw new Error('File has no valid extension')
		const fileName = `${uuidv4()}.${fileExtension}`
		// eslint-disable-next-line no-template-curly-in-string
		const filePath = data.fields.key.replace('${filename}', fileName)
		const body = {
			...data.fields,
			key: filePath,
			file
		}
		const formdataField = getFormData(body)
		await API({ customUrl: s3Url, authorization: true }).post('', formdataField)
		return {
			document_url: `${s3Url}${filePath}`,
			name: fileName,
			type_document: fileExtension ?? ''
		}
	} catch (error) {
		console.error(error)
		return null
	}
}
